import React from 'react';
import { Link } from 'react-router-dom';
import { Chip } from '@biome-design-system/ui/Chip';
import { Box } from '@biome-design-system/ui/Box';
import { SearchIcon } from '@biome-design-system/icons/SearchIcon';
import type { SearchModification } from 'Src/types/search';
import type { GetUpdatedSearch } from 'Src/types';

interface SearchChipProps {
  label: string;
  onClick: () => void;
  queryModifications: SearchModification[];
  getUpdatedSearch: GetUpdatedSearch;
}

export const SearchChip = ({
  label,
  onClick,
  queryModifications = [],
  getUpdatedSearch
}: SearchChipProps) => {
  return (
    <Box component="li">
      <Chip
        component={Link}
        to={getUpdatedSearch(queryModifications)}
        color="primary"
        icon={<SearchIcon />}
        label={label}
        onClick={onClick}
        sx={(theme) => ({
          padding: theme.spacing(1),
          lineHeight: theme.typography.body1.lineHeight
        })}
      />
    </Box>
  );
};
